export const isDebug = false

export const API_ROOT_DEBUG = 'http://localhost:17655'
export const API_ROOT_PROD = 'https://alpheta-server.onrender.com'

export const discordLink = 'https://discord.com/invite/uUdCh9dBQB'
export const instagramLink = 'https://www.instagram.com/alpheta.io/'
export const linkedinLink = 'https://www.linkedin.com/company/alpheta/'
export const twitterLink = 'https://twitter.com/alpheta_io'
export const emailAddress = 'alpheta.nft@gmail.com'
